import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient) { }

  getOrdersForGrid(params) {
    return this.http.post('/orders/grid', params);
  }
  public getOrdersByUserId(userId:number,params) {
    return this.http.post(`/orders/GetOrdersByUserId?userId=${userId}`, params);
  }
  getOrderStatus() {
    return this.http.get('/orders/order-status');
  }
  getOrdersExport(params) {
    var httpPromise = this.http.post('/orders/export', params, { responseType: 'blob' });

    httpPromise.subscribe(function (response) {
      var blob = new Blob([response], { type: "text/csv" });
      // this.getBlob(blob, "orders-export.csv");
      var filename = "orders-export.csv";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      }
      else {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = objectUrl;
        // a.style = "display: none";
        a.download = filename; // gives it a name via an a tag
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      }

    });
  }
  getOrderLinesExport(params) {
    var httpPromise = this.http.post('/orders/lines-export', params, { responseType: 'blob' });

    httpPromise.subscribe(function (response) {
      var blob = new Blob([response], { type: "text/csv" });
      var filename = "order-lines-export.csv";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      }
      else {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = objectUrl;
        // a.style = "display: none";
        a.download = filename; // gives it a name via an a tag
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      }
    });
  }
}

